module.exports = __webpack_public_path__ + "img/16.88a02c69.png";